import React from "react";
import PropTypes from "prop-types";

import { UICallout, UIModal } from "../../../../../../ui";
import { AlertTriangle } from "lucide-react";
import { Box } from "@mui/material";

import "./_EventPayrollRevertConfirmModal.scss";

const EventPayrollRevertConfirmModal = ({
  open,
  variant,
  scope,
  labels,
  shared,
  onClose,
  onConfirm,
}) => {
  const prefix = `${variant}${scope === "all" ? "All" : "Single"}`;
  const showWarning = variant === "deduction" && scope === "all";

  return (
    <UIModal
      className="event-payroll-generate__revert"
      open={open}
      type="info"
      title={labels[`${prefix}Title`]}
      description={labels[`${prefix}Description`]}
      cancelLabel={shared.cancel}
      confirmLabel={labels[`${prefix}Confirm`]}
      onClose={onClose}
      onCancel={onClose}
      onConfirm={onConfirm}
      maxWidth="xs"
    >
      {showWarning ? (
        <UICallout
          variant="warning"
          description={
            <Box>
              <p className="event-payroll-generate__revert-warning-title">
                {labels.deductionAllWarning}
              </p>
              <p className="event-payroll-generate__revert-warning-description">
                {labels.deductionAllWarningDescription}
              </p>
            </Box>
          }
          hasBorder={false}
          icon={
            <AlertTriangle
              size={16}
              strokeWidth={2}
              color="var(--color-warning-default, #F59E0B)"
            />
          }
        />
      ) : null}
    </UIModal>
  );
};

EventPayrollRevertConfirmModal.propTypes = {
  open: PropTypes.bool.isRequired,
  variant: PropTypes.oneOf(["deduction", "reward"]),
  scope: PropTypes.oneOf(["all", "single"]),
  labels: PropTypes.object.isRequired,
  shared: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

EventPayrollRevertConfirmModal.defaultProps = {
  variant: "deduction",
  scope: "all",
};

export default EventPayrollRevertConfirmModal;
